module.exports = __webpack_public_path__ + "img/borderTriangleWhite.c974e816.svg";